"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IFramePreview = void 0;
const button_1 = require("client/components/material/button");
const material_ui_1 = require("material-ui");
const React = require("react");
require("./iframe-preview.less");
class IFramePreview extends React.Component {
    render() {
        const { iframeUrl, title = "" } = this.props;
        const isCsv = iframeUrl.includes(".csv") && !iframeUrl.includes(".txt");
        return (React.createElement("div", { className: "iframe-invoice" },
            React.createElement("div", { className: "iframe-invoice__close-btn" },
                React.createElement(material_ui_1.Typography, { variant: "title", color: "inherit" }, title),
                React.createElement(material_ui_1.Typography, { color: "inherit", variant: "subheading", className: "iframe-invoice__close-btn--text", onClick: this.props.onClose }, "Close")),
            isCsv ? (React.createElement("div", { className: "iframe-invoice__iframe-title" },
                React.createElement(material_ui_1.Typography, { align: "center", variant: "title" }, "Preview of csv file format is not available. To view file, click on the Download button below."),
                React.createElement("iframe", { className: "iframe-invoice__iframe" }))) : (React.createElement("iframe", { className: "iframe-invoice__iframe", src: iframeUrl })),
            React.createElement("div", { className: "iframe-invoice__delete-btn" },
                this.props.onDelete ? (React.createElement(button_1.MaterialButton, { flat: true, className: "iframe-invoice__delete-btn--btn", onClick: this.props.onDelete }, "Delete")) : null,
                this.props.download ? (React.createElement("a", { href: iframeUrl, download: title },
                    React.createElement(button_1.MaterialButton, { flat: true, className: "iframe-invoice__delete-btn--btn" }, "Download"))) : null)));
    }
}
exports.IFramePreview = IFramePreview;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory-order/tabs/order-review/components/iframe-preview/iframe-preview.tsx
// module id = 3430
// module chunks = 0